// Generated from design-system/lib/icons.js. Do not hand edit.
// 53 icons on a 24x24 grid, 1.7 stroke, square terminals and mitred joins.
// Drawn for this product, not imported from a generic pack.

export const ICON_NAMES = [
  "ingot",
  "cathode",
  "scale",
  "gavel",
  "clock",
  "hourglass",
  "wallet",
  "doc",
  "shield",
  "user",
  "building",
  "factory",
  "bell",
  "search",
  "filter",
  "chevron-down",
  "chevron-up",
  "chevron-left",
  "chevron-right",
  "arrow-up",
  "arrow-down",
  "plus",
  "x",
  "check",
  "alert",
  "info",
  "upload",
  "download",
  "eye",
  "edit",
  "trash",
  "external",
  "menu",
  "grid",
  "list",
  "chart",
  "exchange",
  "truck",
  "medal",
  "lock",
  "mobile",
  "calendar",
  "refresh",
  "settings",
  "logout",
  "dots",
  "sort",
  "users",
  "percent",
  "flag",
  "message",
  "star",
  "brand-mark",
] as const

export type IconName = (typeof ICON_NAMES)[number]

const SPRITE = `<svg xmlns="http://www.w3.org/2000/svg" style="position:absolute;width:0;height:0;overflow:hidden" aria-hidden="true">
<defs>
<g id="_s" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="square" stroke-linejoin="miter"></g>
</defs>
<symbol id="i-ingot"    viewBox="0 0 24 24"><path d="M8 6h8l2.5 5h-13L8 6Z"/><path d="M5.5 13h13l2.5 5h-18l2.5-5Z"/></symbol>
<symbol id="i-cathode"  viewBox="0 0 24 24"><path d="M3 8.5 12 5l9 3.5-9 3.5-9-3.5Z"/><path d="M3.4 12.5 12 15.9l8.6-3.4"/><path d="M3.4 16.5 12 19.9l8.6-3.4"/></symbol>
<symbol id="i-scale"    viewBox="0 0 24 24"><path d="M12 4v16"/><path d="M5 7.5h14"/><path d="M5 7.5 2.4 14h5.2L5 7.5Z"/><path d="M19 7.5 16.4 14h5.2L19 7.5Z"/><path d="M8.5 20h7"/></symbol>
<symbol id="i-gavel"    viewBox="0 0 24 24"><path d="m3.5 20.5 7-7"/><path d="M2.5 20.5h5"/><path d="m9.5 9 5.5 5.5"/><path d="M14 2.5 21.5 10l-3 3L11 5.5l3-3Z"/></symbol>
<symbol id="i-clock"    viewBox="0 0 24 24"><circle cx="12" cy="12" r="8.2"/><path d="M12 7v5.2l3.4 2"/></symbol>
<symbol id="i-hourglass" viewBox="0 0 24 24"><path d="M6.5 3h11M6.5 21h11"/><path d="M7.5 3v3.6L12 12l-4.5 5.4V21"/><path d="M16.5 3v3.6L12 12l4.5 5.4V21"/></symbol>
<symbol id="i-wallet"   viewBox="0 0 24 24"><path d="M20 8.5V7a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h13a2 2 0 0 0 2-2v-1.5"/><path d="M15 8.5h6v7h-6a3.5 3.5 0 0 1 0-7Z"/></symbol>
<symbol id="i-doc"      viewBox="0 0 24 24"><path d="M6 2.5h8l4.5 4.5V21.5H6V2.5Z"/><path d="M13.8 2.8V7.2h4.4"/><path d="M9 12.5h6M9 16h4"/></symbol>
<symbol id="i-shield"   viewBox="0 0 24 24"><path d="M12 2.5 4.5 5.6v6.1c0 4.4 3.2 7.2 7.5 9.8 4.3-2.6 7.5-5.4 7.5-9.8V5.6L12 2.5Z"/><path d="m8.6 11.8 2.6 2.6 4.3-4.9"/></symbol>
<symbol id="i-user"     viewBox="0 0 24 24"><circle cx="12" cy="8" r="3.6"/><path d="M4.8 20.2c0-3.7 3.2-6.2 7.2-6.2s7.2 2.5 7.2 6.2"/></symbol>
<symbol id="i-building" viewBox="0 0 24 24"><path d="M4 21V6.2L12 3l8 3.2V21"/><path d="M9.4 21v-5.2h5.2V21"/><path d="M7.6 9.4h2M14.4 9.4h2M7.6 12.8h2M14.4 12.8h2"/><path d="M2.5 21h19"/></symbol>
<symbol id="i-factory"  viewBox="0 0 24 24"><path d="M2.5 21V11l5 3.2V11l5 3.2V6.5h3.4L18 21H2.5Z"/><path d="M20 21h1.5"/><path d="M16.6 6.5V3h3v3.5"/></symbol>
<symbol id="i-bell"     viewBox="0 0 24 24"><path d="M6 9.6a6 6 0 0 1 12 0c0 3.9 1.3 5.3 2 6.4H4c.7-1.1 2-2.5 2-6.4Z"/><path d="M9.8 19a2.4 2.4 0 0 0 4.4 0"/></symbol>
<symbol id="i-search"   viewBox="0 0 24 24"><circle cx="10.8" cy="10.8" r="6.3"/><path d="m15.4 15.4 4.6 4.6"/></symbol>
<symbol id="i-filter"   viewBox="0 0 24 24"><path d="M3 4.5h18l-7.2 8.4v6.2l-3.6 1.9v-8.1L3 4.5Z"/></symbol>
<symbol id="i-chevron-down"  viewBox="0 0 24 24"><path d="m6 9.5 6 6 6-6"/></symbol>
<symbol id="i-chevron-up"    viewBox="0 0 24 24"><path d="m6 14.5 6-6 6 6"/></symbol>
<symbol id="i-chevron-left"  viewBox="0 0 24 24"><path d="m14.5 5-7 7 7 7"/></symbol>
<symbol id="i-chevron-right" viewBox="0 0 24 24"><path d="m9.5 5 7 7-7 7"/></symbol>
<symbol id="i-arrow-up"   viewBox="0 0 24 24"><path d="M12 20.5V4"/><path d="m5.4 10.6 6.6-6.6 6.6 6.6"/></symbol>
<symbol id="i-arrow-down" viewBox="0 0 24 24"><path d="M12 3.5V20"/><path d="m5.4 13.4 6.6 6.6 6.6-6.6"/></symbol>
<symbol id="i-plus"  viewBox="0 0 24 24"><path d="M12 4.5v15M4.5 12h15"/></symbol>
<symbol id="i-x"     viewBox="0 0 24 24"><path d="m5.8 5.8 12.4 12.4M18.2 5.8 5.8 18.2"/></symbol>
<symbol id="i-check" viewBox="0 0 24 24"><path d="m4.8 12.4 4.8 4.8L19.2 6.6"/></symbol>
<symbol id="i-alert" viewBox="0 0 24 24"><path d="M12 3.4 2.2 20.6h19.6L12 3.4Z"/><path d="M12 9.8v5"/><path d="M12 17.4h.1"/></symbol>
<symbol id="i-info"  viewBox="0 0 24 24"><circle cx="12" cy="12" r="8.6"/><path d="M12 11.2v5.6"/><path d="M12 7.4h.1"/></symbol>
<symbol id="i-upload"   viewBox="0 0 24 24"><path d="M12 16V3.6"/><path d="m6.8 8.8 5.2-5.2 5.2 5.2"/><path d="M3.8 15.4v5h16.4v-5"/></symbol>
<symbol id="i-download" viewBox="0 0 24 24"><path d="M12 3.6V16"/><path d="m6.8 10.8 5.2 5.2 5.2-5.2"/><path d="M3.8 15.4v5h16.4v-5"/></symbol>
<symbol id="i-eye"      viewBox="0 0 24 24"><path d="M2.4 12S6.1 5.8 12 5.8 21.6 12 21.6 12 17.9 18.2 12 18.2 2.4 12 2.4 12Z"/><circle cx="12" cy="12" r="2.9"/></symbol>
<symbol id="i-edit"     viewBox="0 0 24 24"><path d="M4 20h4.2L20 8.2 15.8 4 4 15.8V20Z"/><path d="m13.6 6.2 4.2 4.2"/></symbol>
<symbol id="i-trash"    viewBox="0 0 24 24"><path d="M3.8 6.6h16.4"/><path d="M9.2 6.6V3.4h5.6v3.2"/><path d="m6.2 6.6 1 14h9.6l1-14"/></symbol>
<symbol id="i-external" viewBox="0 0 24 24"><path d="M14 3.6h6.4V10"/><path d="M20.4 3.6 11.6 12.4"/><path d="M18 13.6v6.8H3.6V6h6.8"/></symbol>
<symbol id="i-menu"  viewBox="0 0 24 24"><path d="M3.6 6.6h16.8M3.6 12h16.8M3.6 17.4h16.8"/></symbol>
<symbol id="i-grid"  viewBox="0 0 24 24"><path d="M4 4h6.4v6.4H4zM13.6 4H20v6.4h-6.4zM4 13.6h6.4V20H4zM13.6 13.6H20V20h-6.4z"/></symbol>
<symbol id="i-list"  viewBox="0 0 24 24"><path d="M8.4 6.4h12M8.4 12h12M8.4 17.6h12"/><path d="M4 6.4h.1M4 12h.1M4 17.6h.1"/></symbol>
<symbol id="i-chart" viewBox="0 0 24 24"><path d="M3 20.4h18"/><path d="M5.8 20.4v-7.6M11 20.4V5.6M16.2 20.4v-4.8"/></symbol>
<symbol id="i-exchange" viewBox="0 0 24 24"><path d="M3.4 8.8h16"/><path d="m15.4 4.4 4.4 4.4-4.4 4.4"/><path d="M20.6 16.2h-16"/><path d="m8.6 11.8-4.4 4.4 4.4 4.4"/></symbol>
<symbol id="i-truck" viewBox="0 0 24 24"><path d="M2.6 5.6h11.2v11H2.6z"/><path d="M13.8 9h3.8L21 12.6v4h-7.2z"/><circle cx="7" cy="18.4" r="1.9"/><circle cx="17" cy="18.4" r="1.9"/></symbol>
<symbol id="i-medal" viewBox="0 0 24 24"><circle cx="12" cy="15" r="5.2"/><path d="M8.2 10.4 5.4 3.4h13.2l-2.8 7"/><path d="M12 13.2v3.6"/></symbol>
<symbol id="i-lock"  viewBox="0 0 24 24"><path d="M4.6 10.2h14.8v10H4.6z"/><path d="M8 10.2V7.4a4 4 0 0 1 8 0v2.8"/></symbol>
<symbol id="i-mobile" viewBox="0 0 24 24"><path d="M6.6 2.8h10.8v18.4H6.6z"/><path d="M10.4 18.4h3.2"/></symbol>
<symbol id="i-calendar" viewBox="0 0 24 24"><path d="M3.6 5.4h16.8v15.2H3.6z"/><path d="M3.6 10.2h16.8M8.2 2.8v4.6M15.8 2.8v4.6"/></symbol>
<symbol id="i-refresh" viewBox="0 0 24 24"><path d="M20.2 12a8.2 8.2 0 1 1-2.7-6.1"/><path d="M20.4 3.6v4.8h-4.8"/></symbol>
<symbol id="i-settings" viewBox="0 0 24 24"><circle cx="12" cy="12" r="3.1"/><path d="M12 2.6v3M12 18.4v3M2.6 12h3M18.4 12h3M5.4 5.4l2.1 2.1M16.5 16.5l2.1 2.1M18.6 5.4l-2.1 2.1M7.5 16.5l-2.1 2.1"/></symbol>
<symbol id="i-logout" viewBox="0 0 24 24"><path d="M10.2 4.4H4.6v15.2h5.6"/><path d="m15.4 8.2 3.8 3.8-3.8 3.8"/><path d="M19.2 12H8.8"/></symbol>
<symbol id="i-dots" viewBox="0 0 24 24"><path d="M5.6 12h.1M12 12h.1M18.4 12h.1"/></symbol>
<symbol id="i-sort" viewBox="0 0 24 24"><path d="M7.6 4.4v15.2"/><path d="m4 8 3.6-3.6L11.2 8"/><path d="M16.4 19.6V4.4"/><path d="m12.8 16 3.6 3.6L20 16"/></symbol>
<symbol id="i-users" viewBox="0 0 24 24"><circle cx="9.2" cy="8" r="3.4"/><path d="M2.8 19.6c0-3.5 2.9-5.9 6.4-5.9s6.4 2.4 6.4 5.9"/><path d="M15.6 5.2a3.4 3.4 0 0 1 0 5.6"/><path d="M17.4 14.2c2.3.7 3.8 2.7 3.8 5.4"/></symbol>
<symbol id="i-percent" viewBox="0 0 24 24"><path d="m4.6 19.4 14.8-14.8"/><circle cx="7.6" cy="7.6" r="2.7"/><circle cx="16.4" cy="16.4" r="2.7"/></symbol>
<symbol id="i-flag" viewBox="0 0 24 24"><path d="M5 21.4V3"/><path d="M5 3.6h13.4l-2.8 4.6 2.8 4.6H5"/></symbol>
<symbol id="i-message" viewBox="0 0 24 24"><path d="M3.6 4.4h16.8v12.2H9.4l-5.8 4.4V4.4Z"/><path d="M7.6 8.8h9M7.6 12.2h5.6"/></symbol>
<symbol id="i-star" viewBox="0 0 24 24"><path d="m12 3.2 2.8 5.8 6.3.9-4.6 4.5 1.1 6.4-5.6-3-5.6 3 1.1-6.4L2.9 9.9l6.3-.9L12 3.2Z"/></symbol>
<symbol id="i-brand-mark" viewBox="0 0 24 24"><path d="M8.4 5.4h7.2l2.4 4.6H6L8.4 5.4Z"/><path d="M4.6 12.6h14.8l2.4 4.6H2.2l2.4-4.6Z"/></symbol>
</svg>`

/** Injects the symbol sheet once, at the application root. */
export function IconSprite() {
  return <span aria-hidden="true" style={{ display: 'contents' }} dangerouslySetInnerHTML={{ __html: SPRITE }} />
}
